







































































import { Component, Vue, Prop, Model, Watch } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'
import { getOperationID } from '@/api/operations'
import { ApiService } from '@/api/api.service'
import orderBy from 'lodash/orderBy'
import take from 'lodash/take'
import Groupe from '@/components/Groups/Groupe.vue'
import { getBoUrl } from '@/api/http-constants'
import Alert from '@/components/Alert.vue'
import AperGr from '@/components/Groups/AperGr.vue'
import { TicketModule } from '@/store/modules/ticket'

@Component({
    components: {
        Groupe,
        Alert,
        AperGr,
    },
})
export default class EspacesPartages extends Vue {
    @Prop({ type: Boolean }) marginRight
    @Prop({ default: 3 }) maxGroups
    @Model('change', { type: Boolean }) hasModules: boolean

    apiService = new ApiService()
    opeID: number
    userID: number
    allGroups: any[] = []
    boUrl = getBoUrl()

    get suggestedGroups() {
        const groupIdxs = []

        const priorityGroupIdx = this.allGroups.findIndex(
            group => group.group.isPriority
        )
        if (priorityGroupIdx != -1) {
            groupIdxs.push(priorityGroupIdx)
        }

        const maxGroups = Math.min(this.maxGroups, this.allGroups.length)
        while (groupIdxs.length < maxGroups) {
            const rand = Math.floor(Math.random() * this.allGroups.length)
            if (!groupIdxs.includes(rand)) {
                groupIdxs.push(rand)
            }
        }

        const groups = groupIdxs.map(idx => {
            const group = this.allGroups[idx]

            const user = group.users.find(user => {
                return (
                    user.id === this.userID &&
                    ['member', 'waiting'].includes(user.state)
                )
            })

            if (user) {
                group.state = user.state
            }

            return group
        })

        return groups
    }

    get myGroups() {
        return (
            this.allGroups.filter((x: any) => {
                for (let i = 0; i < x.users.length; i++) {
                    if (
                        x.users[i].id === this.userID &&
                        (x.users[i].state === 'member' ||
                            x.users[i].state === 'waiting')
                    ) {
                        return true
                    }
                }
                return false
            }) || []
        )
    }

    get canJoinGroup() {
        return this.myGroups.length < 3
    }

    async created() {
        if (UserModule.token === undefined) {
            UserModule.Init()
        }
        this.userID = UserModule.userInfos.id
        this.opeID = await getOperationID()

        await this.refresh()
    }

    async refresh() {
        const resp = await this.apiService.getGroupsByOperation(this.opeID)
        const allGroups = resp.data
        this.allGroups = allGroups

        if (this.allGroups.length > 0) {
            this.$emit('change', true)
        }
    }

    mounted() {
        const $aperGrpModal = $(this.$refs.aperGrpModal) as any
        $aperGrpModal.on('hidden.bs.modal', this.onModalHidden)
    }

    destroyed() {
        const $aperGrpModal = $(this.$refs.aperGrpModal) as any
        $aperGrpModal.off('hidden.bs.modal', this.onModalHidden)
    }

    showAlert(obj) {
        if (obj.type === 'success') {
            ;(<any>$(this.$refs.groupModal)).modal('hide')
            ;(<any>$(this.$refs.aperGrpModal)).modal('hide')
        }
        ;(<Alert>this.$refs.alert).handleAlert(obj.type, obj.message)
    }

    selectedGroupID: number = null
    showGrp(group) {
        this.selectedGroupID = group.group.id
    }

    showMyModal() {
        const $aperGrpModal = $(this.$refs.aperGrpModal) as any
        $aperGrpModal.modal('show')
    }

    onModalHidden() {
        console.log('modalHidden')
        this.selectedGroupID = null
    }

    // on s'ajoute à un group
    onJoinGroup(args) {
        const { groupID, userData } = args
        const group = this.allGroups.find(group => group.group.id === groupID)
        const userGroup = group.users.find(user => user.id === this.userID)
        if (userGroup) {
            userGroup.state = userData.state
        } else {
            group.users.push({
                ...userData.user,
                state: userData.state,
            })
        }

        TicketModule.refresh()
    }

    // on se supprime d'un group
    onQuitGroup(groupID) {
        const group = this.allGroups.find(group => group.group.id === groupID)

        const userGroup = group.users.find(u => u.id === this.userID)
        const index = group.users.indexOf(userGroup)
        if (index !== -1) {
            group.users.splice(index, 1)
        }

        TicketModule.refresh()
    }

    /**
     * TIPS: On refresh la liste des groupes en observant le ticket
     */
    @Watch('ticketData')
    onTicketData() {
        this.refresh()
    }

    get ticketData() {
        return TicketModule.ticketData
    }
}
